import preloadResponse from "@jspsych/plugin-preload";

import { getLayoutConfigById } from "../../config/keyboardLayoutConfig";
import { p } from "../../lib/markup/tags";
import { LANGUAGE } from "../../config/main";
import { resolveCloudScreenshotUrl, resolveCloudVideoUrl } from "../../lib/utils";
import { getLayoutAssets, getLayoutVideoAssets } from "./preloadLayouts";

const cloudVideo = (relativePath) => resolveCloudVideoUrl(`instructions/videos/${relativePath}`);
const cloudScreenshot = (relativePath) => resolveCloudScreenshotUrl(`instructions/screenshots/${relativePath}`);

const ALL_MISSIONS = [0, 1, 2, 3, 4, 5];

const missionImages = {
  0: [
    cloudScreenshot("screenshots_m0/instructions 0.01.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.02.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.03.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.04 1.02.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.05.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.06.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.07 1.05.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.08.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.09.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.10.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.11.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.12.svg"),
    cloudScreenshot("screenshots_m0/instructions 0.14.svg"),
    cloudScreenshot("screenshots_shared/instructions 2.05 1.07 0.13.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.15 1.09 3.07.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.16 1.10.svg"),
    "assets/images/instructions/custom/extras/m0/spacebarFeedbackFkeyM0.png",
    "assets/images/instructions/custom/extras/m0/spacebarFeedbackKkeyM0.png",
  ],
  1: [
    cloudScreenshot("screenshots_m1/instructions 1.01.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.04 1.02.svg"),
    cloudScreenshot("screenshots_m1/instructions 1.03.svg"),
    cloudScreenshot("screenshots_m1/instructions 1.04.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.07 1.05.svg"),
    cloudScreenshot("screenshots_m1/instructions 1.06.svg"),
    cloudScreenshot("screenshots_m1/instructions 1.08.svg"),
    cloudScreenshot("screenshots_shared/instructions 2.05 1.07 0.13.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.15 1.09 3.07.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.16 1.10.svg"),
  ],
  2: [
    cloudScreenshot("screenshots_m2/instructions 2.01.svg"),
    cloudScreenshot("screenshots_m2/instructions 2.02.svg"),
    cloudScreenshot("screenshots_m2/instructions 2.03.svg"),
    cloudScreenshot("screenshots_m2/instructions 2.04.svg"),
    cloudScreenshot("screenshots_shared/instructions 2.05 1.07 0.13.svg"),
    cloudScreenshot("screenshots_m2/instructions 2.06.svg"),
  ],
  3: [
    cloudScreenshot("screenshots_m3/instructions 3.01.svg"),
    cloudScreenshot("screenshots_m3/instructions 3.02.svg"),
    cloudScreenshot("screenshots_m3/instructions 3.03.svg"),
    cloudScreenshot("screenshots_m3/instructions 3.04.svg"),
    cloudScreenshot("screenshots_m3/instructions 3.05.svg"),
    cloudScreenshot("screenshots_m3/instructions 3.06.svg"),
    cloudScreenshot("screenshots_shared/instructions 0.15 1.09 3.07.svg"),
    cloudScreenshot("screenshots_m3/instructions 3.08.svg"),
  ],
  4: [
    "assets/images/instructions/m4/instructions 4.1.svg",
    "assets/images/instructions/m4/instructions 4.2.svg",
    "assets/images/instructions/m4/instructions 4.3.svg",
    "assets/images/instructions/m4/instructions 4.4.svg",
    "assets/images/instructions/m4/instructions 4.5.svg",
    "assets/images/instructions/m4/instructions 4.6.svg",
    "assets/images/instructions/m4/instructions 4.7.svg",
    "assets/images/instructions/m4/instructions 4.8.svg",
    "assets/images/instructions/m4/instructions 4.9.svg",
    "assets/images/instructions/m4/instructions 4.10.svg",
  ],
  5: [
    cloudScreenshot("screenshots_m5/instructions 5.01.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.02.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.03.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.04.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.05.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.06.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.07.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.08.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.09.svg"),
    cloudScreenshot("screenshots_m5/instructions 5.10.svg"),
    "assets/images/instructions/custom/extras/m5/backgroundM5.svg",
    "assets/images/instructions/custom/extras/m5/videoSlideCommentM5.svg",
  ],
};

const missionVideos = {
  0: [cloudVideo("m0/0_solve.mp4")],
  1: [cloudVideo("m1/1_solve.mp4")],
  2: [cloudVideo("m2/2_truck-interact.mp4"), cloudVideo("m2/2_pass-truck.mp4")],
  5: [
    cloudVideo("m5/mission_5-05.mp4"),
    cloudVideo("m5/mission_5-07.mp4"),
    cloudVideo("m5/mission_5-09.mp4"),
  ],
};

const missionAudio = {
  0: [
    "assets/audio/instructions 0.01.mp3",
    "assets/audio/instructions 0.02.mp3",
    "assets/audio/instructions 0.03.mp3",
    "assets/audio/instructions 0.04.mp3",
    "assets/audio/instructions 0.05.mp3",
    "assets/audio/instructions 0.06.mp3",
    "assets/audio/instructions 0.07.mp3",
    "assets/audio/instructions 0.08.mp3",
    "assets/audio/instructions 0.09.mp3",
    "assets/audio/instructions 0.10.mp3",
    "assets/audio/instructions 0.11.mp3",
    "assets/audio/instructions 0.12.mp3",
    "assets/audio/instructions 0.13.mp3",
    "assets/audio/instructions 2.5.mp3",
    "assets/audio/instructions 0.14.mp3",
    "assets/audio/instructions 0.15.mp3",
  ],
  1: [
    "assets/audio/instructions 1.01.mp3",
    "assets/audio/instructions 1.02.mp3",
    "assets/audio/instructions 1.03.mp3",
    "assets/audio/instructions 1.04.mp3",
    "assets/audio/instructions 1.05.mp3",
    "assets/audio/instructions 1.06.mp3",
    "assets/audio/instructions 1.07.mp3",
    "assets/audio/instructions 2.5.mp3",
    "assets/audio/instructions 1.08.mp3",
    "assets/audio/instructions 1.09.mp3",
  ],
  2: [
    "assets/audio/instructions 2.1.mp3",
    "assets/audio/instructions 2.2.mp3",
    "assets/audio/instructions 2.3.mp3",
    "assets/audio/instructions 2.4.mp3",
    "assets/audio/instructions 2.5.mp3",
    "assets/audio/instructions 2.6.mp3",
  ],
  3: [
    "assets/audio/instructions 3.1.mp3",
    "assets/audio/instructions 3.2.mp3",
    "assets/audio/instructions 3.3.mp3",
    "assets/audio/instructions 3.4.mp3",
    "assets/audio/instructions 3.5.mp3",
    "assets/audio/instructions 3.6.mp3",
  ],
};

const missionImageAssets = Object.values(missionImages).flat();
const missionVideoAssets = Object.values(missionVideos).flat();
const missionAudioAssets = Object.values(missionAudio).flat();

const hasMissionTasks = (missionEntry) => {
  if (!missionEntry || !Array.isArray(missionEntry.taskName)) {
    return false;
  }

  return missionEntry.taskName.length > 0;
};

function getPreloadMissionNumbers(metadata) {
  const missionTaskName = metadata?.missionTaskName;

  if (!Array.isArray(missionTaskName)) {
    return ALL_MISSIONS;
  }

  const missionNumbers = missionTaskName
    .map((missionEntry, missionNumber) => (hasMissionTasks(missionEntry) ? missionNumber : null))
    .filter((missionNumber) => missionNumber !== null && missionNumber >= 0 && missionNumber <= 5);

  return missionNumbers;
}

function getMissionAssets(assetByMission, missionNumbers) {
  return missionNumbers.flatMap((missionNumber) => assetByMission[missionNumber] || []);
}

function pushUniqueAssets(targetAssets, assetsToInject) {
  const existingAssets = new Set(targetAssets);
  assetsToInject.forEach((asset) => {
    if (!existingAssets.has(asset)) {
      targetAssets.push(asset);
      existingAssets.add(asset);
    }
  });
}

export const preloadTrial = {
  type: preloadResponse,
  data: { name: "preloadResources" },
  message: p(LANGUAGE.prompts.settingUp),
  // show_detailed_errors: true,
  // TODO: We're definitely going to need to split up the images
  on_error: function (asset, error) {
    console.error(`[preload] Failed to load asset: ${asset}`);
    if (error) {
      console.error(error);
    }
  },
  images: [
    // Driver images
    "assets/images/driver/collisionDriver.svg",
    "assets/images/driver/defaultDriver.svg",
    "assets/images/driver/happyDriver.svg",
    "assets/images/driver/sadDriver.svg",
    "assets/images/driver/surprisedDriver.svg",

    // Menu images (keyboard layout flow)
    "assets/images/menu/hqHappy.svg",
    "assets/images/menu/hqNeutral.svg",
    "assets/images/menu/idleDriver.svg",

    // Instructions (non-conditional)
    "assets/images/instructions/before_instructions_setEnvironment_1.svg",
    "assets/images/instructions/before_instructions_setEnvironment_2.svg",
    "assets/images/instructions/before_instructions0_Keyboard.svg",
    "assets/images/instructions/before_instructions1_mode_selection.svg",
    "assets/images/instructions/leftInstructionArrow.svg",
    "assets/images/instructions/rightInstructionArrow.svg",
    "assets/images/instructions/video_placeholder.svg",
    "assets/images/instructions/try_again_placeholder.svg",
    "assets/images/instructions/gs01_120px_G_90_6_90_450_set_0004_M0_instructions.png",
    "assets/images/instructions/custom/background.svg",
    "assets/images/instructions/custom/driver.svg",
    "assets/images/instructions/custom/hq-happy.svg",
    "assets/images/instructions/custom/hq-impressed.svg",
    "assets/images/instructions/custom/hq-neutral.svg",
    "assets/images/instructions/custom/hq-speaking.svg",
    "assets/images/instructions/tutorial_tv_placeholder.png",
    "assets/images/instructions/demo_try_again.png",
    "assets/images/instructions/demo_congratulations.png",
    "assets/images/instructions/video_follow_up.png",
    "assets/images/instructions/video_follow_up_2.png",

    // Headquarters custom images
    "assets/images/headquarter/custom/emote-angry.svg",
    "assets/images/headquarter/custom/emote-disgust.svg",
    "assets/images/headquarter/custom/emote-happy.svg",
    "assets/images/headquarter/custom/emote-sad.svg",
    "assets/images/headquarter/custom/emote-surprise.svg",
    "assets/images/headquarter/custom/emote-trust.svg",
    "assets/images/headquarter/custom/slowdownIcon.svg",
    "assets/images/headquarter/custom/spacebarIcon.svg",
    "assets/images/headquarter/custom/speedUpIcon.svg",

    // Emotes
    "assets/images/emotes/emote-angry.svg",
    "assets/images/emotes/emote-disgust.svg",
    "assets/images/emotes/emote-happy.svg",
    "assets/images/emotes/emote-sad.svg",
    "assets/images/emotes/emote-surprise.svg",
    "assets/images/emotes/emote-trust.svg",

    // Layout-specific assets are injected via preloadLayouts.


    // Mafia Icons
    "assets/images/mafiaIcons/iconBrightnessMafia.svg",
    "assets/images/mafiaIcons/iconLetterMafia.svg",
    "assets/images/mafiaIcons/iconNumberMafia.svg",

    // HUD
    "assets/images/hud/bomb_1.svg",
    "assets/images/hud/bomb_2.svg",
    "assets/images/hud/bomb_3.svg",
    "assets/images/hud/bomb_4.svg",
    "assets/images/hud/bomb_5.svg",
    "assets/images/hud/bomb_6.svg",
    "assets/images/hud/bomb_7.svg",
    "assets/images/hud/bomb_8.svg",
    "assets/images/hud/GasAndLabelsGeneric.svg",
    "assets/images/hud/heart-empty.svg",
    "assets/images/hud/heart-full.svg",
    "assets/images/hud/motorcycle-dashboard.svg",
    "assets/images/hud/SpeedAndLabelsGeneric.svg",
    "assets/images/hud/speed-needle.svg",


    // Packages
    "assets/images/packages/package_medium.svg",
    "assets/images/packages/package_high.svg",
    "assets/images/packages/package_low.svg",
    "assets/images/packages/package_1star.svg",
    "assets/images/packages/package_2star.svg",
    "assets/images/packages/package_3star.svg",
    "assets/images/packages/escapePackage_1star.svg",
    "assets/images/packages/escapePackage_2star.svg",
    "assets/images/packages/escapePackage_3star.svg",
    "assets/images/packages/escapePackage_bomb.svg",

    // Postgame
    "assets/images/postgame/carSortBackground.svg",
    "assets/images/postgame/FeedbackScreen_Mission0.svg",
    "assets/images/postgame/FeedbackScreen_Mission1.svg",
    "assets/images/postgame/FeedbackScreen_Mission2.svg",
    "assets/images/postgame/FeedbackScreen_Mission3.svg",
    "assets/images/postgame/FeedbackScreen_Mission4.svg",
    "assets/images/postgame/FeedbackScreen_Mission5.svg",
    "assets/images/postgame/packageSortBackground.svg",
    "assets/images/postgame/postgame 2.svg",
    "assets/images/postgame/postgame 7.svg",
    "assets/images/postgame/postgame 8.svg",
    "assets/images/postgame/postgame 13.svg",
    "assets/images/postgame/CreditsScreen.svg",
    "assets/images/postgame/achievementScreen_mission1.svg",
    "assets/images/postgame/achievementScreen_mission2.svg",
    "assets/images/postgame/achievementScreen_mission3.svg",
    "assets/images/postgame/achievementScreen_mission4.svg",
    "assets/images/postgame/achievementScreen_mission5.svg",

    // Target cars
    "assets/images/targetCars/target_blurred.svg",
    "assets/images/targetCars/target_flat_blue_sad.svg",
    "assets/images/targetCars/target_flat_green_neutral.svg",
    "assets/images/targetCars/target_flat_yellow_happy.svg",
    "assets/images/targetCars/target_round_blue_sad.svg",
    "assets/images/targetCars/target_round_green_neutral.svg",
    "assets/images/targetCars/target_round_yellow_happy.svg",
    "assets/images/targetCars/target_tall_blue_sad.svg",
    "assets/images/targetCars/target_tall_green_neutral.svg",
    "assets/images/targetCars/target_tall_yellow_happy.svg",
    "assets/images/targetCars/target_flat_blue_sad_mirror.svg",
    "assets/images/targetCars/target_flat_green_neutral_absorber.svg",
    "assets/images/targetCars/target_flat_yellow_happy_mirror.svg",
    "assets/images/targetCars/target_round_green_neutral_mirror.svg",
    "assets/images/targetCars/target_tall_blue_sad_tire.svg",
    "assets/images/targetCars/target_tall_green_neutral_absorber.svg",
    "assets/images/targetCars/target_tall_green_neutral_tire.svg",
    "assets/images/targetCars/target_tall_yellow_happy_absorber.svg",
    "assets/images/targetCars/target_tall_yellow_happy_tire.svg",

    // Target cars (m1, probabilistic blocks)
    "assets/images/targetCars/car1_bright.svg",
    "assets/images/targetCars/car2_bright.svg",
    "assets/images/targetCars/car3_bright.svg",
    "assets/images/targetCars/car1_letter.svg",
    "assets/images/targetCars/car2_letter.svg",
    "assets/images/targetCars/car3_letter.svg",
    "assets/images/targetCars/car1_number.svg",
    "assets/images/targetCars/car2_number.svg",
    "assets/images/targetCars/car3_number.svg",

    // Target cars (m4)
    "assets/images/targetCars/target_flat_blue_sad_modelA.svg",
    "assets/images/targetCars/target_flat_blue_sad_modelB.svg",
    "assets/images/targetCars/target_flat_blue_sad_modelC.svg",
    "assets/images/targetCars/target_flat_green_neutral_modelA.svg",
    "assets/images/targetCars/target_flat_green_neutral_modelB.svg",
    "assets/images/targetCars/target_flat_green_neutral_modelC.svg",
    "assets/images/targetCars/target_flat_yellow_happy_modelA.svg",
    "assets/images/targetCars/target_flat_yellow_happy_modelB.svg",
    "assets/images/targetCars/target_flat_yellow_happy_modelC.svg",
    "assets/images/targetCars/target_round_blue_sad_modelA.svg",
    "assets/images/targetCars/target_round_blue_sad_modelB.svg",
    "assets/images/targetCars/target_round_blue_sad_modelC.svg",
    "assets/images/targetCars/target_round_green_neutral_modelA.svg",
    "assets/images/targetCars/target_round_green_neutral_modelB.svg",
    "assets/images/targetCars/target_round_green_neutral_modelC.svg",
    "assets/images/targetCars/target_round_yellow_happy_modelA.svg",
    "assets/images/targetCars/target_round_yellow_happy_modelB.svg",
    "assets/images/targetCars/target_round_yellow_happy_modelC.svg",
    "assets/images/targetCars/target_tall_blue_sad_modelA.svg",
    "assets/images/targetCars/target_tall_blue_sad_modelB.svg",
    "assets/images/targetCars/target_tall_blue_sad_modelC.svg",
    "assets/images/targetCars/target_tall_green_neutral_modelA.svg",
    "assets/images/targetCars/target_tall_green_neutral_modelB.svg",
    "assets/images/targetCars/target_tall_green_neutral_modelC.svg",
    "assets/images/targetCars/target_tall_yellow_happy_modelA.svg",
    "assets/images/targetCars/target_tall_yellow_happy_modelB.svg",
    "assets/images/targetCars/target_tall_yellow_happy_modelC.svg",

    "assets/images/targetCars/target_precue_number.svg",
    "assets/images/targetCars/target_precue_letter.svg",
    "assets/images/targetCars/target_precue_brightness.svg",

    // Context Cues (m4)
    "assets/images/contextCues/contextCue_cloud.png",
    "assets/images/contextCues/contextCue_sun.png",

    // Trucks (m4)
    "assets/images/truck/truck_flat_blue_sad.svg",
    "assets/images/truck/truck_flat_green_neutral.svg",
    "assets/images/truck/truck_flat_pink_sad.svg",
    "assets/images/truck/truck_flat_yellow_happy.svg",
    "assets/images/truck/truck_round_blue_sad.svg",
    "assets/images/truck/truck_round_green_neutral.svg",
    "assets/images/truck/truck_round_pink_sad.svg",
    "assets/images/truck/truck_round_yellow_happy.svg",
    "assets/images/truck/truck_tall_blue_sad.svg",
    "assets/images/truck/truck_tall_green_neutral.svg",
    "assets/images/truck/truck_tall_pink_sad.svg",
    "assets/images/truck/truck_tall_yellow_happy.svg",

    // Trucks (m2)
    "assets/images/truck/truck_flat_orange_happy.svg",
    "assets/images/truck/truck_flat_purple_neutral.svg",
    "assets/images/truck/truck_flat_red_sad.svg",
    "assets/images/truck/truck_round_orange_happy.svg",
    "assets/images/truck/truck_round_purple_neutral.svg",
    "assets/images/truck/truck_round_red_sad.svg",
    "assets/images/truck/truck_tall_orange_happy.svg",
    "assets/images/truck/truck_tall_purple_neutral.svg",
    "assets/images/truck/truck_tall_red_sad.svg",

    // Mode selection
    "assets/images/mode_selection.svg",

    // Truck Propose Lane
    "assets/images/truckProposesLane/truckProposesLane1.png",
    "assets/images/truckProposesLane/truckProposesLane2.png",
    "assets/images/truckProposesLane/truckProposesLane3.png",
    "assets/images/truckProposesLane/truckProposesLane5.png",
    "assets/images/truckProposesLane/truckProposesLane6.png",
    "assets/images/truckProposesLane/truckProposesLane7.png",
    "assets/images/truckProposesLane/truckProposesLaneX.png",

    //Mission 5 Gang Cars
    "assets/images/gangCars/gang_high.svg",
    "assets/images/gangCars/gang_medium.svg",
    "assets/images/gangCars/gang_low.svg",

    ...getMissionAssets(missionImages, ALL_MISSIONS),
  ],
  audio: [
    "assets/audio/CG01_01_LockOn_V1.wav",
    "assets/audio/CG01_05_Crash_V1.wav",
    "assets/audio/CG01_06_Message_V1.wav",
    "assets/audio/CG01_07_Package_V1.wav",
    "assets/audio/CG01_08_Trucks_V1.wav",
    "assets/audio/CG01_09_ShiftLane_V1.wav",
    "assets/audio/CG01_10_Celebrate_V1.wav",
    "assets/audio/CG01_11_LicencePlate_V1.wav",
    "assets/audio/CG01_12_Ambience_V1_2min_loop.mp3",
    "assets/audio/CG01_02_Happy_V1.wav",
    "assets/audio/CG01_03_Sad_V1.wav",
    "assets/audio/CG01_04_Surprise_V1.wav",

    ...getMissionAssets(missionAudio, ALL_MISSIONS),
  ],
  video: [
    // basic controls instructions videos
    cloudVideo("basicControls/lock.mp4"),
    cloudVideo("basicControls/speed_slow.mp4"),
    cloudVideo("basicControls/speed_up.mp4"),

    ...getMissionAssets(missionVideos, ALL_MISSIONS),
  ],
};

export function configureMissionPreloadAssets(metadata) {
  const missionNumbers = getPreloadMissionNumbers(metadata);

  preloadTrial.images = [
    ...preloadTrial.images.filter((asset) => !missionImageAssets.includes(asset)),
    ...getMissionAssets(missionImages, missionNumbers),
  ];

  preloadTrial.video = [
    ...preloadTrial.video.filter((asset) => !missionVideoAssets.includes(asset)),
    ...getMissionAssets(missionVideos, missionNumbers),
  ];

  preloadTrial.audio = [
    ...preloadTrial.audio.filter((asset) => !missionAudioAssets.includes(asset)),
    ...getMissionAssets(missionAudio, missionNumbers),
  ];
}

/**
 * Injects remaining layout-specific assets into preloadTrial.
 * Call this after keyboard layout detection, before running the timeline.
 * @param {string} layoutId - e.g. "QWERTY_USUK", "AZERTY_FR", "QWERTZ_DECH"
 */
export function injectLayoutAssets(layoutId) {
  const assets = getLayoutAssets(layoutId);
  const videos = getLayoutVideoAssets(layoutId);
  window._gear_layoutConfigId = layoutId;
  window._gear_layoutConfig = getLayoutConfigById(layoutId);
  pushUniqueAssets(preloadTrial.images, assets);
  pushUniqueAssets(preloadTrial.video, videos);
  // console.log(`[preload] preloadTrial.images after injecting "${layoutId}" (${preloadTrial.images.length} total):`);
  // preloadTrial.images.forEach((img) => console.log(img));
}
